import { render, staticRenderFns } from "./settingWebzi.vue?vue&type=template&id=6e6079d9&scoped=true&"
import script from "./settingWebzi.vue?vue&type=script&lang=js&"
export * from "./settingWebzi.vue?vue&type=script&lang=js&"
import style0 from "./settingWebzi.vue?vue&type=style&index=0&id=6e6079d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6079d9",
  null
  
)

export default component.exports